<template>
  <div
    v-if="condition.type == CONDITION_TYPES.GROUP"
    class="condition-group"
  >
    <div class="d-flex justify-content-end align-items-center gap-2 mb-2">
      <select
        class="form-control w-auto"
        v-model="condition.value"
      >
        <option :value="GROUP_MATCHS_TYPES.ALL">Todas las condiciones</option>
        <option :value="GROUP_MATCHS_TYPES.ANY">Cualquier condición</option>
      </select>

      <b-button
        size="sm"
        variant="outline-danger"
        class="shadow"
        title="Eliminar condición"
        v-b-tooltip.hover="'Eliminar grupo de condiciones'"
        @click="removeGroup(index, level)"
        :data-level="level"
        :disabled="level == 0"
      >
        <feather-icon icon="TrashIcon"/>
      </b-button>
    </div>
    <!-- Condition Cards -->
    <div class="space-y-4 condition-list">
      <ConditionRenderer
        v-for="(condition, $index) in condition.conditions"
        :key="$index"
        :condition="condition"
        :index="$index"
        :level="level+1"
        @removeGroup="removeGroup"
        @removeCondition="removeCondition"
        :jsonPathTypes="jsonPathTypes"
      />
    </div>
    <div>
      <!--   Button to add condition   -->
      <b-button
        title="Agregar nueva condición"
        v-b-tooltip.hover="'Agregar nueva condición'"
        size="sm"
        variant="outline-primary"
        class="btn-icon mt-2 text-center shadow"
        @click="addCondition()"
      >
        <feather-icon icon="PlusIcon"/>
      </b-button>
      <!--   Button to add subgroup   -->
      <b-button
        size="sm"
        title="Agregar nuevo grupo de condiciones"
        v-b-tooltip.hover="'Agregar nuevo grupo de condiciones'"
        variant="outline-primary"
        class="btn-icon mt-2 text-center shadow ml-2"
        @click="addGroup()"
      >
        <feather-icon icon="CodeIcon"/>
      </b-button>
    </div>
  </div>
  <div class="grid grid-cols-4 gap-4 items-start condition-row" v-else>
    <!-- Columna 1 -->
    <div>
      <select
        class="w-full px-3 py-2 border border-gray-300 rounded-lg"
        v-model="condition.path"
        placeholder="Ingrese un xpath para interpretar en el evento"
        @change="setPath(condition.path)"
      >
        <option
          v-for="(path) in jsonPathTypes"
          :key="path.value"
          :value="path.value"
        >
          {{ path.label }}
        </option>
      </select>
      <small v-if="selectedJsonPath && selectedJsonPath.description">
        {{selectedJsonPath.description}}
      </small>
    </div>

    <!-- Columna 2 -->
    <select
      class="w-full px-3 py-2 border border-gray-300 rounded-lg"
      v-model="condition.operator"
    >
      <option
        v-for="(match, key) in CONDITION_MATCH_TYPES_NAMES"
        :key="key"
        :value="key"
      >
        {{ match }}
      </option>
    </select>

    <!-- Columna 3: Inputs de valor -->
    <div>
      <!-- Múltiples valores -->
      <template v-if="CONDITION_IS_MULTIPLE.includes(condition.operator)">
        <div
          v-for="(val, valIndex) in condition.value"
          :key="valIndex"
          :data-index="valIndex"
          :data-value="condition.value[valIndex]"
          class="flex items-center gap-2 mb-1"
        >
          <input
            type="text"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg"
            v-model="condition.value[valIndex]"
            placeholder="Ingrese un valor"
          />
          <b-button
            size="sm"
            class="mr-2"
            variant="outline-danger"
            @click="condition.value.splice(valIndex, 1)"
          >
            <feather-icon icon="MinusIcon"/>
          </b-button>
        </div>
        <b-button
          size="sm"
          variant="outline-primary"
          @click="addValueToCondition(condition,valIndex)"
        >
          <feather-icon icon="PlusIcon"/>
        </b-button>
      </template>

      <!-- Valor único numérico -->
      <input
        type="number"
        class="w-full px-3 py-2 border border-gray-300 rounded-lg"
        placeholder="Ingrese el número"
        v-else-if="CONDITION_IS_NUMERIC.includes(condition.operator)"
        v-model="condition.value"
      />

      <!-- Valor único texto -->
      <input
        type="text"
        class="w-full px-3 py-2 border border-gray-300 rounded-lg"
        placeholder="Ingrese el valor"
        v-else
        v-model="condition.value"
      />
    </div>

    <!-- Columna 4: Botón eliminar condición -->
    <div class="flex justify-end">
      <b-button
        size="sm"
        variant="outline-danger"
        class="shadow"
        title="Eliminar condición"
        v-b-tooltip.hover="'Eliminar condición'"
        @click="removeCondition(index, level)"
      >
        <feather-icon icon="TrashIcon"/>
      </b-button>
    </div>
  </div>

</template>
<script>
/* eslint-disable */

import { BButton } from 'bootstrap-vue';

import { jsonPathTypes } from '@/febos/global/rules/util/rules';

import {
  buildEmptyCondition,
  buildEmptyGroup,
  CONDITION_IS_MULTIPLE,
  CONDITION_IS_NUMERIC,
  CONDITION_MATCH_TYPES_NAMES,
  CONDITION_TYPES,
  GROUP_MATCHS_TYPES
} from '@/febos/global/rules/util/rules';

export default {
  name: 'ConditionRenderer',
  data() {
    return {
      selectedJsonPath: {}
    }
  },
  components: { BButton },
  computed: {
    CONDITION_TYPES() {
      return CONDITION_TYPES;
    },
    GROUP_MATCHS_TYPES() {
      return GROUP_MATCHS_TYPES;
    },
    CONDITION_MATCH_TYPES_NAMES() {
      return CONDITION_MATCH_TYPES_NAMES;
    },
    CONDITION_IS_NUMERIC() {
      return CONDITION_IS_NUMERIC;
    },
    CONDITION_IS_MULTIPLE() {
      return CONDITION_IS_MULTIPLE;
    }
  },
  props: {
    condition: {
      type: Object
    },
    index: {
      type: Number
    },
    level: {
      type: Number,
      default: 0
    },
    jsonPathTypes: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    setPath(path) {
      const pathSelected = this.jsonPathTypes.find((el) => el.value === this.condition.path);
      if (pathSelected) {
        this.selectedJsonPath = pathSelected;
      }
    },
    addCondition() {
      this.condition.conditions = this.condition.conditions || [];
      this.condition.conditions.push(buildEmptyCondition());
    },
    addGroup() {
      this.condition.conditions = this.condition.conditions || [];
      this.condition.conditions.push(buildEmptyGroup(CONDITION_TYPES.GROUP));
    },
    addValueToCondition(condition) {
      // validar si value es array, si no es array, transformarlo en array
      if (!Array.isArray(condition.value)) {
        condition.value = [condition.value];
      }
      condition.value.push('');
    },
    removeCondition(index, level) {
      console.info('removeCondition', index, level, this.condition)
      if (level > this.level) {
        this.condition.conditions.splice(index, 1);
      } else {
        // emitir el evento al componente padre
        this.$emit('removeCondition', index, level);
      }
    },
    removeGroup(index, level) {
      console.info('removeGroup', index, level, this.condition)
      if (level > this.level) {
        this.condition.conditions.splice(index, 1);
      } else {
        // emitir el evento al componente padre
        this.$emit('removeGroup', index, level);
      }
    }
  },
  mounted() {
    this.setPath();
  }
};
</script>
<style scoped>
.condition-group {
  padding: 1rem;
  border: 0.5px dashed rgb(var(--vs-primary));
}

.condition-row {
  padding: 0.3rem;
  border: 0.1px dashed rgb(var(--vs-primary));
}

.condition-list {
  padding: 1rem;
}
</style>
